import Headroom from 'headroom.js';

const myElement = document.querySelector(".main-header__inner");
if ( myElement ) {
    const headroom  = new Headroom(myElement);
    headroom.init();
}



// WEBPACK FOOTER //
// ./themes/default/assets/js/headroom.js